import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];
    api.post("/auth/session", { session_id })
      .then((r) => {
        setUser(r.data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { state: { user: r.data.user }, replace: true });
      })
      .catch(() => nav("/login", { replace: true }));
  }, [location, nav, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="nb-card p-8">
        <div className="text-2xl font-extrabold">Signing you in…</div>
        <div className="text-sm text-neutral-500 mt-2">One moment.</div>
      </div>
    </div>
  );
}
